import { initSentry } from "@kalodata/sentry";

import { createClipSentryBeforeSend } from "./apis/http/sentryFilters";

window.CLIP_VERSION = CLIP_VERSION;

const isLocalHost = ["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname);

if (import.meta.env.MODE !== "development" && !isLocalHost) {
  initSentry({
    dsn: "https://c7de3f67d1392e53f74273c6d0778266@o4511347902578688.ingest.us.sentry.io/4511494772817920",
    project: "kaloclip-web",
    release: CLIP_VERSION,
    environment: import.meta.env.MODE,
    // 降本：staging 重度采样保留低速率可见性；同类错误 session 内去重抑制重复刷量。
    // transport/timeout/abort 与业务态 4xx 已在 HTTP 层 shouldReportHttpError 源头收口。
    beforeSend: createClipSentryBeforeSend({
      environment: import.meta.env.MODE,
      stagingSampleRate: 0.1,
      maxPerFingerprint: 3,
    }),
  });
}
